import { ActionBase } from '../../../core/store/action/ActionBase';
import { SupportTicketModel } from '../../models/SupportTicketModel';

export const SUBMIT_SUPPORT_TICKET_ACTION = '[Configuration] Submit Support Ticket Action';

export class SubmitSupportTicketAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SUBMIT_SUPPORT_TICKET_ACTION;

  constructor(public payload: { model: SupportTicketModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/SubmitSupportTicketAction.ts